import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('Falta el node #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Installability is what unlocks the Android share sheet and protocol handlers.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Not fatal: the app works fine, it just cannot be installed as a WebAPK.
    })
  })
}
